/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Example_Step_5Inputs */

const da_forside_example_step_5 = /** @type {(inputs: Forside_Example_Step_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vælg besvarelserne, tryk »Start rettelse«, og gennemgå forslagene ved siden af besvarelserne.`)
};

/** @type {(inputs: Forside_Example_Step_5Inputs) => LocalizedString} */
const en_forside_example_step_5 = da_forside_example_step_5;

/**

* @param {Forside_Example_Step_5Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_example_step_5 = /** @type {((inputs?: Forside_Example_Step_5Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Example_Step_5Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_example_step_5(inputs)
	return /** @type {LocalizedString} */ ("Vælg besvarelserne, tryk »Start rettelse«, og gennemgå forslagene ved siden af besvarelserne.")
});